import DialogSingleDayType from "./DialogSingleDayType";

export default {
    name     : 'dialog_single_day_type',
    component: DialogSingleDayType,
    dialog   : {
        'max-width': "600px",
        'persistent': true
    }
}
